import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;
const COMPANY_CODE = process.env.REACT_APP_COMPANY_CODE;

const setFaviconHref = (href) => {
  let link = document.querySelector("link[rel*='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = href;

  // Update apple-touch-icon if exists
  const appleLink = document.querySelector("link[rel='apple-touch-icon']");
  if (appleLink) appleLink.href = href;
};

// Reset favicon to default
export const resetFavicon = () => {
  setFaviconHref("/favicon.ico");
};

// Fetch company logo from API and update favicon
export const fetchAndUpdateFavicon = async () => {
  if (!COMPANY_CODE) {
    console.warn("No company code configured");
    return;
  }

  try {
    const response = await axios.get(
      `${BASE_URL}/api/customer/company/get-company-logo`,
      {
        params: { company_code: COMPANY_CODE },
      }
    );

    const companyLogo = response.data?.company_logo;

    if (companyLogo) {
      const faviconUrl = `${BASE_URL}/uploads/company_logos/${companyLogo}`;
      setFaviconHref(faviconUrl);
    } else {
      resetFavicon();
    }
  } catch (error) {
    console.error("Error fetching company logo:", error);
    resetFavicon();
  }
};
